// extracted by mini-css-extract-plugin
module.exports = {"desktopMenu":"desktop-menu-module--desktop-menu--UekcF","activeMenuItem":"desktop-menu-module--active-menu-item--2Mp6O","socialIcon":"desktop-menu-module--social-icon--1C4J2"};